globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.LocalManagement = appCustomerSpace.Controllers.LocalManagement || {};

appCustomerSpace.Controllers.LocalManagement.ContactController = (function(superClass) {

    utils.extend(ContactController, superClass);

    function ContactController() {
        return ContactController.__super__.constructor.apply(this, arguments);
    }

    $.extend(ContactController.prototype, {
        init: function(){
            this.initEvents();

            return ContactController.__super__.init.apply(this, arguments);
        },
        initEvents: function(){
            var $form = $('form.location-contact-form');

            function displayPhonneError($input, state) {
                if($input.val() == "") return;

                if(state) {
                    console.log('append');
                    if(!$input.closest('.form-group').find('.validation-error-label').length) {
                        $input.closest('.form-group').append('<p class="validation-error-label">Numéro incorrect</p>');
                    }
                } else {
                    $input.closest('.form-group').find('.validation-error-label').remove();
                }
            };

            $(".intl-tel-input").each(function(){
                var $this = $(this);
                $this.intlTelInput({
                    initialCountry: $(this).data('country-code'),
                    separateDialCode: true,
                    preferredCountries: ["fr"],
                    formatOnDisplay: true,
                    hiddenInput: $this.data('input-name'),
                    utilsScript: "intlTelInput/utils.js"
                });

                displayPhonneError($this, !$this.intlTelInput('isValidNumber'));

                $this.on('change', function(){
                    displayPhonneError($this, !$this.intlTelInput('isValidNumber'));
                })
            });

            var $form = $('form.location-contact-form'),
                $btnChangeAddress = $form.find('.btn-change-address');
                $inputGeocoder = $form.find("input#find_address");

            var setGmapHeight = function(){
                $('#accounts_business_form_submission_location_attributes_address_map').css('height', $('#address-text-components')[0].offsetHeight + 'px')
            }

            if($('#accounts_business_form_submission_location_attributes_address_map').length) {
                setGmapHeight();
            }

            $btnChangeAddress.on('click', function(){
                $btnChangeAddress.closest('.form-group').find('.edit-address-fields').toggle().find('input').first().focus();
            });

            $form.find('#accounts_business_form_submission_location_attributes_address_line_2').on('change', function(){
                $form.find('[data-address-component="line_2"]').html($(this).val())
            });

            $inputGeocoder.addresspicker({
                apiKey: helpers.google.api.key,
                elements: {
                    map: '#accounts_business_form_submission_location_attributes_address_map',
                    lat: '#accounts_business_form_submission_location_attributes_address_latitude',
                    lng: '#accounts_business_form_submission_location_attributes_address_longitude',
                    postal_code: '#accounts_business_form_submission_location_attributes_address_postal_code',
                    locality: '#accounts_business_form_submission_location_attributes_address_city_name',
                    country: '#accounts_business_form_submission_location_attributes_address_country',
                    country_code: '#accounts_business_form_submission_location_attributes_address_region_code'
                },
                mapOptions: { zoom: 15 },
                draggableMarker: !$inputGeocoder.prop('disabled'),
                reverseGeocode: !$inputGeocoder.prop('disabled'),
                updateCallback: function(geocodeResult, parsedGeocodeResult) {
                    var address_line_1 = [];
                    if(parsedGeocodeResult.street_number) address_line_1.push(parsedGeocodeResult.street_number);
                    if(parsedGeocodeResult.route) address_line_1.push(parsedGeocodeResult.route);

                    $form.find("#accounts_business_form_submission_location_attributes_address_line_1").val(address_line_1.join(" "));

                    Object.keys(parsedGeocodeResult).forEach(function(key) {
                        var $addressComponent = $form.find('[data-address-component='+ key +']');
                        if($addressComponent.length) $addressComponent.html(parsedGeocodeResult[key]);
                    });

                    if(!$form.find('#selected-address-container').is('visible')) $form.find('#selected-address-container').fadeIn();

                    $(".intl-tel-input").each(function(){ $(this).intlTelInput("setCountry", parsedGeocodeResult.country_code) });
                    setGmapHeight();
                }
            })

        }
    });

    return ContactController;

})(appCustomerSpace.Controllers.LocalManagement.MainController);
